import { render, staticRenderFns } from "./AddCustomEmailSenderModal.vue?vue&type=template&id=39f35c92&scoped=true"
import script from "./AddCustomEmailSenderModal.vue?vue&type=script&lang=js"
export * from "./AddCustomEmailSenderModal.vue?vue&type=script&lang=js"
import style0 from "./AddCustomEmailSenderModal.vue?vue&type=style&index=0&id=39f35c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f35c92",
  null
  
)

export default component.exports